<template>
  <a-config-provider :locale="locale">
    <router-view v-if="!loading"></router-view>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { LESSONPLAY_TOKEN } from './config/url';
import headPath from '@/filter/headPath';

export default {
  name: "App",
  data() {
    return {
      locale: zhCN,
      loading: true,
      token:""
    }
  },
  components: {},
  mounted() {
    if (!this.$device.desktop()) {
      this.loading = false;
      return this.$router.push(`/warning`)
    };
    this.judgeToken();
  },
  methods: {
    //判断token
    async judgeToken() {
      //const token = process.env.NODE_ENV === 'development' ? 'development' : window.localStorage.getItem(LESSONPLAY_TOKEN);
      const token = window.localStorage.getItem(LESSONPLAY_TOKEN);
      //localStorage中不存在token时，先尝试从URL中获取token
      if (!token) {
        const urlToken = this.getURLToken()
        //URL中也不存在token，跳转到认证中心检查（其他应用）是否已经登录过
        if (!urlToken) this.loadFunction();

        //URL中存在token，验证该token的有效性（这种情况一般发生在首次登录）
        else {
          const ret = await this.$api.passport.verifyToken(urlToken)

          //URL中的token有效，将该token写入localStorage并删除URL中的token
          if (ret.status === 1) {
            window.localStorage.setItem(LESSONPLAY_TOKEN, urlToken)
            this.deleteURLToken()
           
            this.userGuid = ret.userGuid;
            this.token = ret.token;
          }
          //URL中的token无效，删除URL中的token并跳转到登录页（这种情况一般是用户手动在URL后面添加了token参数）
          else this.deleteURLToken();

          this.loadFunction();
        }
      }

      //localStorage中存在token时，验证该token的有效性
      else {
        const ret = await this.$api.passport.verifyToken(token)
        //localStorage中的token有效
        if (ret.status === 1){
          this.userGuid = ret.userGuid
          this.token = ret.token;
        }

        //localStorage中的token无效，清除该token并跳转到认证中心检查（其他应用）是否已经登录过
        else window.localStorage.removeItem(LESSONPLAY_TOKEN)
        this.loadFunction();
      }
    },
    //删除URL中的token
    deleteURLToken() {
      const searchParams = new URLSearchParams(location.search)
      searchParams.delete('token')
      const newURL = searchParams.toString() ? `${location.pathname}?${searchParams.toString()}` : location.pathname
      history.pushState({}, '', newURL)
    },
    //获取URL中的token
    getURLToken() {
      const search = new URLSearchParams(location.search)
      const urlToken = search.get('token')
      return urlToken
    },
    //加载方法
    async loadFunction() {
      let userGuid = this.userGuid;
      let user = null;
      if (userGuid) {
        user = await this.$api.classMessage.getStudent({ userGuid: userGuid }).then(res => res.data);
        if (user) {
          user.HeadPhotoPath = headPath(user.HeadPhotoPath);
          user.Name = user.NickName || user.Name;
          user.token = this.token;
        }
      }

      this.$store.commit('userInfo', user);
      this.loading = false;
      if (!userGuid) this.$router.push(``);
    }
  }
};
</script>

<style>
</style>